import React from 'react'
import { connect } from 'react-redux'
import { Box, Divider, Grid, CardMedia, Input } from '@material-ui/core'
import { viewStyles } from '../styles/styles'
import { templates } from '../defaults/templates'
import { selectTemplate, setFormName } from '../actions/settings'
import RightPreviewPart from './RightPreviewPart'
import CancelFormButton from '../containers/CancelFormButton'

const ViewTemplate = ({ settings, selectTemplate, setFormName }) => {
    const classes = viewStyles()
    return (
        <Box className={classes.box_view}>
            <Box className={classes.leftBox}>
                <Box className={classes.titleLeft}>
                    Start by selecting a form template
                </Box>
                <Box className={classes.tmplList}>
                    <Grid container justifyContent="space-between" wrap="wrap" spacing={3}>
                        {
                            templates.map((template) => {
                                let classBox = classes.templateBox;
                                if(settings.template === template.name)
                                    classBox += " selected"
                                return(
                                    <Grid key={template.id} item xs={6}>
                                        <Box className={classBox} onClick={() => selectTemplate(template)}>
                                            <CardMedia component="img" src={`${window.resourcesURL}/images/${template.image}`}></CardMedia>
                                        </Box>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                    {/* <Box m="20px 0">
                        <Divider ></Divider>
                    </Box>
                    <Box >
                        <Box className={classes.titleLeft}>
                            Name of this Form
                        </Box>
                        <Box>
                            <Input value={settings.form.Name} className={classes.nameInput} onChange={(e) => {setFormName(e.target.value)}} disableUnderline={true} placeholder="Type a new name"></Input>
                        </Box>
                    </Box>                     */}
                </Box>
               

            </Box>
            <Box className={classes.bottomBox} m="5px 0 5px 0px">
                <Grid item xs={2}>
                    <CancelFormButton />
                </Grid>
            </Box>

            <Divider orientation="vertical" className={classes.devider}></Divider>
            <Box className={classes.rightBox}>
                <RightPreviewPart></RightPreviewPart>
            </Box>                                  
        </Box>

    )
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    selectTemplate: (template) => dispatch(selectTemplate(template)),
    setFormName: name => dispatch(setFormName(name))
})

export default connect(mapStateToProps, mapDispatchToProps)(ViewTemplate)